import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const phoneNumber = '917011370322'; // WhatsApp number without + sign

  const defaultMessages = [
    "I'm interested in Pool Cleaning Robots",
    "I want to know about Floor Cleaning Robots",
    "Tell me about Window Cleaning Robots",
    "I need a quote for my property",
    "Schedule a demo at my location"
  ];

  const handleSendMessage = (msg) => {
    const encodedMessage = encodeURIComponent(msg || message || 'Hello Harpalyk, I would like to know more about your robotic cleaning solutions.');
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
    setIsOpen(false);
    setMessage('');
  };

  return (
    <>
      {/* WhatsApp Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-20 right-4 lg:bottom-6 lg:right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        {isOpen ? (
          <X className="w-6 h-6" />
        ) : (
          <MessageCircle className="w-6 h-6" />
        )}
      </button>

      {/* WhatsApp Chat Widget */}
      {isOpen && (
      <div className="fixed bottom-40 right-4 lg:bottom-24 lg:right-6 z-50 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden animate-in slide-in-from-bottom-5 duration-300">
          {/* Header */}
          <div className="bg-green-500 p-4 text-white">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <MessageCircle className="w-6 h-6 text-green-500" />
              </div>
              <div>
                <h3 className="font-bold">Harpalyk Support</h3>
                <p className="text-sm text-green-100">Typically replies within minutes</p>
              </div>
            </div>
          </div>

          {/* Chat Body */}
          <div className="p-4 bg-gray-50">
            <div className="bg-white p-3 rounded-lg shadow-sm mb-4">
              <p className="text-gray-700 text-sm">
                👋 Hello! Welcome to Harpalyk. How can we help you today?
              </p>
            </div>

            {/* Quick Reply Buttons */}
            <p className="text-xs text-gray-500 mb-2">Quick Messages:</p>
            <div className="space-y-2 max-h-40 overflow-y-auto">
              {defaultMessages.map((msg, index) => (
                <button
                  key={index}
                  onClick={() => handleSendMessage(msg)}
                  className="w-full text-left bg-white p-2 rounded-lg text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-all border border-gray-100"
                >
                  {msg}
                </button>
              ))}
            </div>
          </div>

          {/* Input Area */}
          <div className="p-4 border-t border-gray-100">
            <div className="flex gap-2">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message..."
                className="flex-1 px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-green-500 text-sm"
                onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
              />
              <button
                onClick={() => handleSendMessage()}
                className="bg-green-500 hover:bg-green-600 text-white p-2 rounded-lg transition-all"
              >
                <Send className="w-5 h-5" />
              </button>
            </div>
            <p className="text-xs text-gray-400 mt-2 text-center">
              Chat with us on WhatsApp
            </p>
          </div>
        </div>
      )}

      {/* Pulsing indicator when closed */}
      {!isOpen && (
        <span className="fixed bottom-20 right-4 lg:bottom-6 lg:right-6 z-40 flex h-14 w-14">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
        </span>
      )}
    </>
  );
};

export default WhatsAppWidget;
